import NotificationsList from './NotificationsList';

export default NotificationsList;